import { resources as uiDefaultResources, ns as uiNs } from "@povio/ui";
import deepMerge from "deepmerge";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { AppConfig } from "./app.config";
import translationEN from "./locales/en/translation.json";
import uiTranslationEN from "./locales/en/ui-translation.json";
import translationSL from "./locales/sl/translation.json";

export const defaultLanguage = "en";
export const defaultNS = "main";

export const defaultResources = {
  en: {
    [defaultNS]: translationEN,
  },
  sl: {
    [defaultNS]: translationSL,
  },
};

const uiResources = deepMerge(uiDefaultResources, { en: { [uiNs]: uiTranslationEN } });

export const resources = deepMerge(defaultResources, uiResources);

i18n.use(initReactI18next).init({
  compatibilityJSON: "v4",
  fallbackLng: defaultLanguage,
  debug: AppConfig.i18nextDebug,
  resources,
  ns: Object.keys(resources.en),
  defaultNS,
  lng: defaultLanguage,
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
